exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pic-size {\r\n    width:120px;\r\n    height:120px;\r\n    margin: 10px 0 0 0;\r\n  }\r\n  .dl-size{\r\n    width: 200px;\r\n    height: 120px;\r\n    margin: 10px 0 0 0;\r\n  }\r\n  \r\n  .mt-2{\r\n  margin-top:20px; \r\n  } \r\n  .mb-2 {\r\n    margin-bottom:20px; \r\n  }\r\n  span.glyphicon.glyphicon-triangle-top {\r\n    color: #fff;\r\n    font-size: 16px;\r\n  }\r\n  \r\n  .action-btn{\r\n    float: none;\r\n    display: block;\r\n    margin: 5px auto;\r\n    text-align: center;\r\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/users/supervisors/supervisors.component.css
// module id = ../../../../../src/app/users/supervisors/supervisors.component.css
// module chunks = main